import { TeachingHall } from '../../../lib/types/models/ol/teaching-hall/teaching-hall'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getTeachingHall({ id, olId }: { id: number; olId: number }) {
  return restApiClient
    .url(constructApiUrl(API.ols.getTeachingHall.url, { id, olId }))
    .get<TeachingHall>()
}
